import { Component, ContentChild, Input, TemplateRef, ViewChild,
    ChangeDetectionStrategy
} from '@angular/core';
import { SmTabContentDirective } from '../../directives/sm-tab-content.directive';

export type SmTabContentLoadMode = "eager" | "lazy" | "destroyOnHide";

@Component({
  selector: 'sm-tab',
  standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './sm-tab.component.html'
})
export class SmTabComponent {
  @Input() value?: string;
  @Input() header?: string;
  @Input() tabClass?: string;
  @Input() tabStyle?: Record<string, string>;
  @Input() headerIcons?: string[];
  @Input() headerBadge: string | number = null;
  @Input() headerBadgeTooltip: string = null;
  @Input() headerBadgeSeverity: 'secondary' | 'info' | 'success' | 'warn' | 'danger' | 'contrast' = null;
  @Input() disabled = false;
  @Input() closable = false;
  @Input() keepChangeDetectionActive = false;
  @Input() contentLoadMode?: SmTabContentLoadMode;
  @ContentChild(SmTabContentDirective) content?: SmTabContentDirective;
  @ViewChild('defaultContentTpl', { static: true }) defaultContentTpl!: TemplateRef<unknown>;

  get contentTpl(): TemplateRef<unknown> {
    return this.content?.templateRef ?? this.defaultContentTpl;
  }

  hasDedicatedContentTemplate(): boolean {
    return this.content != null;
  }
}
